import { useQuery } from "@tanstack/react-query";
import formatCategories from "src/helpers/formatCategories";
import api from "src/newApi";

import { getService } from "../helpers/isPes";
import options from "./defaultOptions";

export function useGetArticleByQuestionId(id, enabled = true) {
	return useQuery({
		queryKey: [`articles-${getService()}-${id}`],
		queryFn: () => api.getArticlesByQuestionIds([id]),
		...options,
		enabled: !!enabled,
		gcTime: 60 * 1000,
	});
}

export function useGetArticlesCategories() {
	return useQuery({
		queryKey: ["articlesCategories"],

		queryFn: async () => {
			const data = await api.getArticlesCategories();
			return formatCategories(data);
		},

		...options,
	});
}
